// extracted by mini-css-extract-plugin
module.exports = {"features":"VehicleFeaturesSection_features__Vvvf6","withContentAbove":"VehicleFeaturesSection_withContentAbove__cZ1s6"};